export default __webpack_public_path__ + "e2bb6d7cb10a5dcf7c2394596e12bed4.png";